import { Navigate, Outlet } from 'react-router-dom';

import type { UserProfile } from '../api/types';
import { useAuth } from '../contexts/AuthContext';

type Props = {
  check: (user: UserProfile) => boolean;
  redirectTo?: string;
};

export default function PermissionRoute({ check, redirectTo = '/tickets' }: Props) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading…</div>;
  }

  if (!user || !check(user)) {
    return <Navigate to={redirectTo} replace />;
  }
  return <Outlet />;
}
